import apiClient from "./apiClient";
import { Product, ProductApiResponse } from "../types/product";

const PRODUCTS_PATH = "products";

export const getAllProducts = async (
  search = "", // New
  status = "", // New
): Promise<ProductApiResponse> => {
  try {
    const params: any = {};
    if (search) params.search = search;
    if (status) params.status = status;

    // Use params in the request
    const response = await apiClient.get<ProductApiResponse>(
      `${PRODUCTS_PATH}/all`,
      { params },
    );
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const createProduct = async (
  productData: FormData,
): Promise<Product> => {
  try {
    // Let axios set multipart boundary — do not set Content-Type manually
    const response = await apiClient.post<Product>(
      `${PRODUCTS_PATH}/create-product`,
      productData,
    );
    return response.data;
  } catch (error) {

    throw error;
  }
};

export function getProductApiErrorMessage(error: unknown): string {
  if (typeof error === "object" && error !== null && "response" in error) {
    const data = (
      error as { response?: { data?: { message?: string | string[] } } }
    ).response?.data;
    const message = data?.message;
    if (Array.isArray(message)) return message.join(", ");
    if (typeof message === "string") return message;
  }
  return "Failed to save product.";
}

export const updateProductStatus = async (
  productId: string,
  newStatus: string,
): Promise<any> => {
  try {
    const response = await apiClient.patch(`${PRODUCTS_PATH}/update-status`, {
      productId,
      newStatus,
    });
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const deleteProduct = async (productId: string): Promise<void> => {
  try {
    await apiClient.delete(`${PRODUCTS_PATH}/${productId}`);
  } catch (error) {

    throw error;
  }
};

export type ProductDetailResponse = {
  success?: boolean;
  message?: string;
  product: Product;
};

export const getProductById = async (
  productId: string,
): Promise<ProductDetailResponse> => {
  try {
    const response = await apiClient.get<ProductDetailResponse>(
      `${PRODUCTS_PATH}/${productId}`,
    );
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const updateProduct = async (
  productId: string,
  productData: FormData,
): Promise<Product> => {
  try {
    const response = await apiClient.patch<Product>(
      `${PRODUCTS_PATH}/${productId}`,
      productData,
    );
    return response.data;
  } catch (error) {

    throw error;
  }
};
